//CODE_CHECK : Kindly remove commented code. Component lifeCycle hook and observer and common functions can be declared ordered manner[corrected]
Lyte.Component.register("lyte-editor-directory-panel-item",{
  data: function () {
    return {
      item: Lyte.attr("object", { default: {} }),
      root : Lyte.attr('boolean'),
      hierarchy : Lyte.attr("number"),
      isFilesOpen: Lyte.attr("boolean", { default: false }),
      activeFilePath: Lyte.attr("string"),
      uniqueId: Lyte.attr("string"),
      duration: Lyte.attr("string", { default: undefined }),
      newName: Lyte.attr("string"),
      msg: Lyte.attr("object"),
      restrict : Lyte.attr("boolean",{default:false}),
      restrictParent : Lyte.attr("boolean",{default : false}),
      errorMessage: Lyte.attr("string", { default: "" }),
      message: Lyte.attr("string", { default: "" }),
      isInputShow: Lyte.attr("boolean", { default: false }),
      inFileOrFolderCreation: Lyte.attr("string", { default: "" }),
      popOverValidate: Lyte.attr("string", { default: '' }),
      popoverRename : Lyte.attr("boolean", { default: false }),
      isRename: Lyte.attr("boolean", { default: false }),
      isFile: Lyte.attr("boolean", { default: false }),
      renameInvalid: Lyte.attr("boolean", { default: false }),
      renameValue: Lyte.attr("string", {
        default: ""
      }),
      openState : Lyte.attr("boolean",{ //No I18n
        default : false
      }),
      restrictMenuIcon : Lyte.attr('boolean',{default : false}),
      sort : Lyte.attr('boolean',{
        default : true
      })
    };
  },
  restrictFlagChecker : function() {
    return this.data.restrict || this.data.restrictParent;
  },
  didConnect: function () {
    this.initializePanelItem();
    if(this.data.openState == true){this.setData("isFilesOpen",true);}
    
  },
   didDestroy() {
    const itemData = this.getData("item");
    const allow = this.restrictFlagChecker()!=true;
    const sort = this.data.sort==true;
    allow && sort && $L(this.$node).droppable("destroy");
    allow && sort &&  $L(this.$node).draggable("destroy");
    this.disposeSubscribedEventByName("RESET_LEFTPANEL");
    if (this.executeMethod("onBeforeDidDestroy")) {
      const itemArray = this.getChildren();
      const itemArrLen = itemArray.length;
      const fileStart = _led
        .getInstance(this.getData("editorId"))
        .folder.getDirectoryData(itemData.id).fileStart;
      for (
        let fileIterate = fileStart;
        fileIterate < itemArrLen;
        fileIterate++
      ) {
        const fileItemId = itemArray[fileIterate].id;
        this.getEditorInstance(this.getData("editorId")).pubsub.fire(
          "DISPOSE_TABITEM",
          fileItemId
        );
      }
      allow && this.fileDragHandler(function (fileNode) {
        fileNode.draggable("destroy");
      });
    }
  },
  popoverDataObserver : function(popoverData){
    this.throwEvent('popOverData',{
      [popoverData.item] : popoverData.newValue
    })
  }.observes('popOverValidate','popoverRename'),
  showFilesObserver: function (observerEvent) {
    const newVal = observerEvent.newValue;
    
    if (newVal) {
      const revokeFn = function () {
        this.createFileOpenModal(false);
      };
      this.subscribeTo("RESET_LEFTPANEL", revokeFn.bind(this));
    } else {
      this.disposeSubscribedEventByName("RESET_LEFTPANEL");
    }
  }.observes("isFilesOpen"),
  sortObserver : function(observerEvent){
      this.initializePanelItem();
  }.observes('sort'),
  restrictObserver : function(obsObj){
        const newValue = obsObj.newValue;
        if(newValue==true)
        {
            this.destroyDraggable();
            this.destroyDroppable();
            this.fileDragHandler(function(fileNode){
              fileNode.draggable("destroy");
            })
        }
        else if(newValue==false){
            this.setDragAndDrop();
        }
  }.observes('restrict'),
  getInputFieldSelector : function(){
    return "lyte-input.leInput";
  },
   setDragAndDrop : function(options) {

    if(options){
      if(options.drag){
         !this.getData("root") && this.makeMeDraggable($L(this.$node.querySelector('.le-item-header')));
      }
      if(options.drop){
         this.makeMeDroppable();
    this.fileDragHandler(function (fileNode) {
      this.makeMeDraggable(fileNode);
    });
      }
    }
    else{
         !this.getData("root") && this.makeMeDraggable($L(this.$node.querySelector('.le-item-header')));
    this.makeMeDroppable();
    this.fileDragHandler(function (fileNode) {
      this.makeMeDraggable(fileNode);
    });
    }
    
  },
  initializePanelItem : function(){
    const allowToSort  = !this.restrictFlagChecker() && this.data.sort==true;
     !this.getData("root") && allowToSort &&  this.setDragAndDrop({drag : true})
     if(allowToSort)
      {
         this.subscribeTo(
      "SETDRAGANDDROP",
      function () {
        !this.restrictFlagChecker() && this.data.sort==true &&  this.setDragAndDrop();
      }.bind(this)
    );
        this.setDragAndDrop({drop : true});
  }
  },
  getItemData : function(id){
    if(this.getData('item').id==id)
    {
      return this.getData('item');
    }
    else{
        const children = this.getChildren();
        return children.find(eachChild=>eachChild.id===id) || false;
    }
  },
  getFileIndex: function (itemId) {
    return _led.getInstance(this.data.editorId).directory.getOrderIndex(itemId);
  },
  setPopOverData : function(dataObj){
    this.setData(dataObj);
  },
  doesAllowToDirCreate : function(){
    const popOverData = this.getData('popOverValidate');
    return !popOverData=='error' || popOverData=='warn' || !popOverData;
  },
  createFileOpenModal: function (value) {
    this.setData("isFilesOpen", value);
  },
  resetErrorPopOver : function(){
    this.setPopOverData({popOverValidate :  '',popoverRename : false});
    this.throwEvent('resetErrorPopOver');
  },
  getChildren: function () {
    const item = this.getData("item");
    if (item.children) {
      return item.children;
    } else {
      console.warn("This is not a folder");
      return false;
    }
  },
   activateCurrent() {
    const isRoot = this.getData("root");
    if(isRoot)
    {
        this.throwEvent("activateMe");
    }
    else{
       this.activateItem(this.$node.querySelector("div"), "leHighlight",this.getData("item").id);
    }
   
  },
  fileActivation : function(fileId,selector,node){
          const editorInstance = _led.getInstance(this.data.editorId);
    const file = editorInstance.folder.getDirectoryData(fileId);
    const activateFileResult = this.executeMethod("makeActive", fileId);
    if(activateFileResult)
    {
      this.activateItem(node, selector, fileId);
    }
  },
  findFileExtension: function (value) {
    const fileSubArray = value.split(".");
    const fileSubLength = fileSubArray.length;
    if (fileSubLength === 1) {
      return false;
    } else {
      return fileSubArray[fileSubLength - 1];
    }
  },
  fileDragHandler : function(callback){
    const childNodes = this.$node.querySelectorAll(':scope>.files>[is-file=true]');
    childNodes.forEach(element => {
      callback.call(this,$L(element));
        
    });
  },
  getFormat : function(format, path, leftPanel) {
    if(leftPanel && leftPanel.defaultFormat && leftPanel.defaultFormat[path] && leftPanel.defaultFormat[path] != format) {
      return leftPanel.defaultFormat[path];
    }
  },
  fileExtensionMaker: function (value) {
    const editorInstance = this.getEditorInstance(this.getData("editorId"));
    const leftPanelConfig = editorInstance.getData("ltPropLeftPanelConfig");
    const extens = ".txt";
    const primaryExtensions = ["js", "css", "html", "json","py","java","jsp","sh","md","db","properties","xml","txt", "jpg", "jpeg", "gif", "png", "bmp", "svg", "webp", "ico", "mp4", "ogv", "mov", "webm", "flac", "wav", "mp3", "oga", "m4a"];
    const format = value.lastIndexOf(".") > -1 ? value.split(".").at(-1) : "";
    const isStandard = primaryExtensions.includes(format);
    const item = this.getData("item");
    let defaultFormat;
    if(item) {
      const folder = editorInstance.folder.getDirectoryData(item.id);
      defaultFormat = this.getFormat(format, folder.path, leftPanelConfig);
    }
    value = defaultFormat ?  value + "." + defaultFormat : isStandard ? value : value +"."+extens;
    return value;
  },
  sortCallback: function (droppables) {
    const isHidden = function (droppableElement) {
      const hidden = window.getComputedStyle(droppableElement).visibility;
      return hidden === "hidden";
    };
    const length = droppables.length;
    let lastElem = droppables[length - 1];
    let lastElemBcr = lastElem.getBoundingClientRect();
    let lastElemVisibility = isHidden(lastElem);
    for (let i = 0; i < length - 1; i++) {
      const currElem = droppables[i];
      const currElemBcr = currElem.getBoundingClientRect();
      const conditions = {
        currHasLast: currElem.contains(lastElem),
        currHeightIsBig: currElemBcr.height > lastElemBcr.height,
        currWidthIsBig: currElemBcr.width > lastElemBcr.width,
        isVisibilityHidden: isHidden(currElem)
      };
      if (conditions.isVisibilityHidden) {
        droppables.splice(i, 1);
        droppables.push(currElem);
      } else if (
        !lastElemVisibility &&
        (conditions.currHasLast ||
          (conditions.currHeightIsBig && conditions.currWidthIsBig))
      ) {
        droppables.splice(droppables.indexOf(lastElem), 1);
        droppables.splice(i, 0, lastElem);
        lastElem = droppables[length - 1];
        lastElemBcr = lastElem.getBoundingClientRect();
        lastElemVisibility = isHidden(lastElem);
        i++;
      }
    }
  },
  deleteOnDom: function (id) {
      const parentId = this.getData('item').id;
      if(parentId===id)
      {
          this.throwEvent('deleteChildItem',id);
      }
      else{
        const childItems = this.getChildren();
        const indx = childItems.findIndex(eachChild=>eachChild.id===id);
        this.crudOnDom(childItems, {
      position: "removeAt",
      index: indx,
      count: 1
    });
      }
  },
  deleteDirData: function (id) {
    this.deleteOnDom(id);
    this.getEditorInstance(this.getData("editorId")).folder.deleteFolderDir(
      id, 
      true
    );
  },
  renameDataAndDom : function(itemId , inputValue , item , isFile , oldObj , preventActive , editorInstance){
    /* Flow : it rename name in data block then take itemDirObj {name,path,uniqueId} then trigger onFileRename after deleteDom before createDom */
      this.modifyDirectory(itemId, {
              value: inputValue,
              type: item.type,
              oldName: item.name
            });
            const newItemObj = editorInstance.directory.getSingleDirectory(
              editorInstance.folder.getDirectoryData(itemId)
            );
            if (isFile) {
              const itemChildren = this.getChildren();
              this.deleteOnDom(itemId);
              editorInstance.triggerMethod("onFileRename", editorInstance.directory.getFileModelObj( newItemObj.id ), oldObj);
              this.createDirOnDom(newItemObj, item.type, itemChildren, preventActive);
            } else {
              const parentComp = this.getParentComp();
              const itemChildren = parentComp.getChildren();
              this.deleteOnDom(itemId);
              editorInstance.triggerMethod("onFolderRename", editorInstance.directory.getFolderModelObj( newItemObj.id ), oldObj );
              parentComp.createDirOnDom(newItemObj, item.type, itemChildren, preventActive);
            }
            editorInstance.pubsub.fire( "FORCERENDER" );

  },
  renameDirItem(itemId,inputValue,preventActive ,failureCallback){
    /*
    Flow -Check file or folder if file we change value into valuewithextenstion then handle onBeforeRename callback if fail in beforeRename callback we call failCallback
   */
    const item = this.getItemData(itemId);
            const isFile = item.type == "file" || false;
            let oldObj;
            // const itemId = item.id;
           
            // CODE_CHECK :  why you are using execute method here ? you can use this.[[fileExtensionMaker[corrected]
            const editorInstance = this.getEditorInstance(
              this.getData("editorId")
            );
            if (isFile) {
              inputValue = this.fileExtensionMaker(inputValue);
              oldObj = editorInstance.directory.getFileModelObj( itemId ); 
            }else{
              oldObj = editorInstance.directory.getFolderModelObj( itemId );
            }
            let result = true;
            const beforeResult = editorInstance.triggerMethod("onBeforeFileRename",inputValue, oldObj);
            if(beforeResult instanceof Promise){
                beforeResult.then(()=>{
                  this.renameDataAndDom(itemId , inputValue , item , isFile , oldObj , preventActive , editorInstance);
                }).catch((error)=>{
                    failureCallback && failureCallback(error);
                })
            }
            else if( !editorInstance.getMethods('onBeforeFileRename') || beforeResult){
                this.renameDataAndDom(itemId , inputValue , item , isFile , oldObj , preventActive , editorInstance);
            }
            else{
              failureCallback();
            }
            

  },
  actions: {
    activateMe: function () {
      this.activateCurrent();
      return false;
    },
    renameDirectory: function (node,itemId,eventObj) {
      const key = ["enter"];
      const item = this.getItemData(itemId);
      if (key.includes(eventObj.key.toLowerCase())) {
        let inputValue = this.getData("renameValue"), oldObj;
        if (this.doesAllowToDirCreate()) {
          const isFile = item.type=='file' || false;
          // const itemId = item.id;
          const editorInstance = this.getEditorInstance(
            this.getData("editorId")
          );
          this.resetErrorPopOver();
          //RenameDir and set failure callback if any failure happened
          const result = this.renameDirItem(itemId , inputValue , false , function(){
              node.blur();
          });
          
        
          // CODE_CHECK :  why you are using execute method here ? you can use this.[[fileExtensionMaker[corrected]
          // if (isFile) {
          //   inputValue = this.fileExtensionMaker(inputValue);
          //   oldObj = editorInstance.directory.getFileModelObj( itemId ); 
          // }
          // else{
          //   oldObj = editorInstance.directory.getFolderModelObj( itemId );
          // }
          //  this.modifyDirectory(itemId, {
          //     value: inputValue,
          //     type: item.type,
          //     oldName: item.name
          //   });
          // const newItemObj = editorInstance.directory.getSingleDirectory(
          //   editorInstance.folder.getDirectoryData(itemId)
          // );
          // if(isFile)
          // {
          //   const itemChildren = this.getChildren();
          //   this.deleteOnDom(itemId);
          //   editorInstance.triggerMethod("onFileRename", editorInstance.directory.getFileModelObj( newItemObj.id ), oldObj);
          //   this.createDirOnDom(newItemObj,item.type,itemChildren);
          //   this.getEditorInstance(this.getData("editorId")).pubsub.fire(
          //     "FORCERENDER"
          //   );
          // }
          // else{
          //   const parentComp = this.getParentComp();
          //   const itemChildren = parentComp.getChildren();
          //   this.deleteOnDom(itemId);
          //   editorInstance.triggerMethod("onFolderRename", editorInstance.directory.getFolderModelObj( newItemObj.id ), oldObj );
          //   parentComp.createDirOnDom(newItemObj,item.type,itemChildren);
          //   this.getEditorInstance(this.getData("editorId")).pubsub.fire(
          //     "FORCERENDER"
          //   );
          // }
        }
      }
      this.activeItem = item;
    },
    deleteChildItem: function (id) {
      this.deleteOnDom(id);
      return false;
    },
    menuOptionClicked: function (node, bool) {
      this.getEditorInstance(this.getData("editorId")).pubsub.fire(
        "SET_MENUDATA",
        this.getData("item").id
      );
      return false;
    },
    displayHighlighter: function (value, selector, node) {
      if(value) {
        node.classList.add("leHighlight");
      }
      else {
        node.classList.remove("leHighlight");
      }
    },
    toggleFiles: function (node, selector) {
      this.throwEvent("restrictedFileType", this.getData("item"));
      this.activateItem(node, selector,this.getData('item').id);
      this.createFileOpenModal(!this.getData("isFilesOpen"));
      return false;
    },
    inputLyteKeydown: function (inputEl, e) {
      const key = ["enter"];
      const fileType = this.getData("inFileOrFolderCreation");
      let value = this.getData("name");
      if (key.includes(e.key.toLowerCase()) && this.doesAllowToDirCreate()) {
        const editorInstance = _led.getInstance(this.getData("editorId"));
        const directoryData = editorInstance.folder.getDirectoryData(this.data.item.id);
        if(editorInstance.triggerMethod('onBeforeCreate', fileType, directoryData, value) === false) {
          this.executeMethod("inputFieldBlur", inputEl);
          this.setPopOverData({popOverValidate : ''});
          return;
        }
        value = fileType=='file' ? this.fileExtensionMaker(value): value;
        const createdItem = this.createDirOnDataAndDom(value, fileType,undefined,this.getChildren());
        if (createdItem) {
          this.activateItemById(createdItem.id);
          this.executeMethod("inputFieldBlur", inputEl);
          this.setPopOverData({popOverValidate : ''});
        }
      }
    },
    openDirectoryUi: function (value = true) {
      this.createFileOpenModal(value);
      return true;
    },
    clickAction: function () {
      return false;
    },
    activatingFile: function (fileId, selector, node) {
      this.fileActivation(fileId,selector,node);
      return false;
    }
  },
  methods: {
      renameBlur: function (inputNode,itemId) {
        const item = itemId ? this.getItemData(itemId) : this.activeItem;
        this.focusOutAction(inputNode, {
          isRename: false
        });
        Lyte.Component.set(item,'isRename', false);
        Lyte.Component.set(item,'ext',this.findFileExtension(item.name));
        delete this.activeItem;
      },
      getChildData: function (index) {
        const childArray = this.getChildren();
        return childArray[index];
      }
  }
},{
  mixins: ["ledMakeActive", "ledManageSubEvents", "ledLeftPanelUtils"]
});
